/* eslint-disable @typescript-eslint/no-unused-vars */
/****************************************************************************
 * Copyright 2021 EPAM Systems
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ***************************************************************************/
/* eslint-disable @typescript-eslint/no-use-before-define */

import { RenderersManager } from 'application/render/renderers/RenderersManager';
import { Operation } from 'domain/entities/Operation';
import { MonomerToAtomBond } from 'domain/entities/MonomerToAtomBond';

export class MonomerToAtomBondAddOperation implements Operation {
  public monomerToAtomBond: MonomerToAtomBond;
  constructor(
    public addMonomerToAtomBondChangeModel: (
      monomerToAtomBond?: MonomerToAtomBond,
    ) => MonomerToAtomBond,
    public deleteMonomerToAtomBondChangeModel: (
      monomerToAtomBond: MonomerToAtomBond,
    ) => void,
  ) {
    this.monomerToAtomBond = this.addMonomerToAtomBondChangeModel();
  }

  public execute(renderersManager: RenderersManager) {
    this.monomerToAtomBond = this.addMonomerToAtomBondChangeModel(
      this.monomerToAtomBond,
    );
    renderersManager.addMonomerToAtomBond(this.monomerToAtomBond);
  }

  public invert(renderersManager: RenderersManager) {
    if (this.monomerToAtomBond) {
      this.deleteMonomerToAtomBondChangeModel(this.monomerToAtomBond);
      renderersManager.deleteMonomerToAtomBond(this.monomerToAtomBond);
    }
  }
}

export class MonomerToAtomBondDeleteOperation implements Operation {
  constructor(
    public monomerToAtomBond: MonomerToAtomBond,
    public deleteMonomerToAtomBondChangeModel: (
      monomerToAtomBond?: MonomerToAtomBond,
    ) => void,
    public addMonomerToAtomBondChangeModel: (
      monomerToAtomBond?: MonomerToAtomBond,
    ) => MonomerToAtomBond,
  ) {}

  public execute(renderersManager: RenderersManager) {
    this.deleteMonomerToAtomBondChangeModel(this.monomerToAtomBond);
    renderersManager.deleteMonomerToAtomBond(this.monomerToAtomBond);
  }

  public invert() {
    this.addMonomerToAtomBondChangeModel(this.monomerToAtomBond);
  }

  public invertAfterAllOperations(renderersManager: RenderersManager) {
    renderersManager.addMonomerToAtomBond(this.monomerToAtomBond);
  }
}
